import { useEffect, useState } from "react";
import axios from "../helper/axios";

let cachedMap = null;
let loadPromise = null;

function fetchPromotionsMap() {
  if (cachedMap) return Promise.resolve(cachedMap);
  if (!loadPromise) {
    loadPromise = axios
      .get("/promotions/active-map")
      .then((res) => {
        cachedMap = res.data?.promotions && typeof res.data.promotions === "object"
          ? res.data.promotions
          : {};
        return cachedMap;
      })
      .catch(() => {
        cachedMap = {};
        return cachedMap;
      })
      .finally(() => {
        loadPromise = null;
      });
  }
  return loadPromise;
}

function getEntry(map, location) {
  if (!location || !map) return null;
  const entry = map[String(location).trim()];
  if (!entry) return null;
  if (typeof entry === "string") {
    const description = entry.trim();
    return description ? { description, allowDiscountedItems: false } : null;
  }
  const description = (entry.description || "").trim();
  if (!description) return null;
  return {
    description,
    allowDiscountedItems: entry.allowDiscountedItems === true,
  };
}

/** Shiriti i brand page (shfaqet gjithmonë kur ka promocion). */
export function getPromotionLabelForLocation(map, location) {
  return getEntry(map, location)?.description || null;
}

/** Badge në kartë produkti — vetëm kur allowDiscountedItems === true. */
export function getPromotionBadgeForProduct(map, location) {
  const entry = getEntry(map, location);
  if (!entry?.allowDiscountedItems) return null;
  return entry.description;
}

export default function useActivePromotionsMap() {
  const [promotionsByLocation, setPromotionsByLocation] = useState(() => cachedMap || {});
  const [loading, setLoading] = useState(!cachedMap);

  useEffect(() => {
    let cancelled = false;
    fetchPromotionsMap().then((map) => {
      if (cancelled) return;
      setPromotionsByLocation(map);
      setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return { promotionsByLocation, loading };
}
